/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-28 14:34:13
 * @LastEditTime: 2022-08-23 19:33:36
 * @Description: desc
 */
import Layout from '../views/Layout'
export default [
  {
    path: '/search',
    component: Layout,
    name: 'Search Management',
    redirect: '/search/hbase/cluster_list',
    meta: { title: 'search' },
    children: [
      {
        path: 'business',
        name: 'business',
        redirect: '/search/business/list',
        component: () => import('../views/business/index.vue'),
        meta: { title: 'Business' },
        children: [
          {
            path: 'access',
            name: 'business-access',
            component: () => import('../views/business/access.vue')
          },
          {
            path: 'list',
            name: 'business-list',
            component: () => import('../views/business/list.vue')
          },
          {
            path: 'consumer',
            name: 'consumer',
            component: () => import('../views/business/consumer.vue')
          }
        ]
      },
      {
        path: '/search/request',
        name: 'Request',
        meta: { title: 'request' },
        redirect: '/search/request/list',
        component: () => import('../views/request/index.vue'),
        children: [
          {
            path: 'list',
            name: 'List',
            component: () => import('../views/request/list.vue')
          },
          {
            path: 'create',
            name: 'Detail',
            component: () => import('../views/request/form.vue'),
            props: route => ({ formTitle: route.params.title })
          }
        ]
      },
      {
        path: 'rest',
        name: 'Rest',
        component: () => import('../views/rest/index.vue'),
        meta: { title: 'Rest' },
        children: [
          {
            path: 'terminal',
            name: 'terminal',
            component: () => import('../views/rest/terminal.vue')
          },
          {
            path: 'history',
            name: 'history',
            component: () => import('../views/rest/history.vue')
          }
        ]
      },
      {
        path: 'discover',
        name: 'Discover',
        component: () => import('../views/discover/index'),
        meta: { title: 'Discover' }
      },
      {
        path: 'index',
        name: 'Index',
        component: () => import('../views/index/index.vue'),
        meta: { title: 'Index' },
        children: [
          {
            path: 'config',
            name: 'business-config',
            component: () => import('../views/index/business.vue')
          },
          {
            path: 'timed-task',
            name: 'timed-task',
            component: () => import('views/index/timed-task.vue')
          },
          {
            path: 'tools',
            name: 'tools',
            component: () => import('views/index/tools.vue')
          },
          {
            path: 'consistency',
            name: 'consistency',
            component: () => import('views/index/consistency.vue')
          },
          {
            path: 'script',
            name: 'script',
            component: () => import('views/index/script.vue')
          },
          {
            path: 'reindex',
            name: 'reindex',
            component: () => import('views/index/reindex.vue')
          }
        ]
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('../views/service/index.vue'),
        meta: { title: 'Service' },
        children: [
          {
            path: 'service-health',
            name: 'service-health',
            component: () => import('../views/service/service-health.vue')
          },
          {
            path: 'config-info',
            name: 'config-info',
            component: () => import('../views/service/config-info.vue')
          },
          {
            path: 'command',
            name: 'command',
            component: () => import('../views/service/command.vue')
          },
          {
            path: 'server',
            name: 'server',
            component: () => import('../views/service/server.vue')
          }
        ]
      },
      {
        path: 'migrate',
        name: 'migrate',
        component: () => import('../views/migrate/migrate.vue'),
        meta: { title: 'Migrate' },
        children: [
          {
            path: 'cluster',
            name: 'cluster-migrate',
            component: () => import('../views/migrate/cluster.vue')
          },
          {
            path: 'history',
            name: 'history-migrate',
            component: () => import('../views/migrate/history.vue')
          }
        ]
      },
      {
        path: 'incident',
        name: 'Incident',
        component: () => import('../views/IncidentNotification.vue'),
        meta: { title: 'Incident' }
      },
      {
        path: 'nginx',
        name: 'nginx',
        component: () => import('../views/nginx/nginx.vue'),
        meta: { title: 'Nginx' },
        children: [
          {
            path: 'HA-AA-Switch',
            name: 'HA-AA-Switch',
            component: () => import('../views/nginx/HA-AA-Switch.vue')
          },
          {
            path: 'upstreams',
            name: 'Upstreams',
            component: () => import('../views/nginx/upstreams.vue')
          },
          {
            path: 'keyvals',
            name: 'Keyvals',
            component: () => import('../views/nginx/keyvals.vue')
          }
        ]
      },
      {
        path: 'cache',
        name: 'cache',
        component: () => import('../views/cache/cache.vue'),
        meta: { title: 'Cache' },
        children: [
          {
            path: 'manage',
            name: 'manage',
            component: () => import('../views/cache/manage.vue')
          },
          {
            path: 'compare',
            name: 'compare',
            component: () => import('../views/cache/compare.vue')
          }
        ]
      },
      {
        path: 'job',
        name: 'job',
        component: () => import('../views/deploy_check/job')
      },
      {
        path: 'system',
        name: 'system',
        component: () => import('../views/system/System'),
        children: [
          {
            path: 'user',
            name: 'user',
            component: () => import('../views/system/User')
          },
          {
            path: 'tenant',
            name: 'tenant',
            component: () => import('../views/system/Tenant')
          },
          {
            path: 'role',
            name: 'role',
            component: () => import('../views/system/Role')
          },
          {
            path: 'permission',
            name: 'permission',
            component: () => import('../views/system/Permission')
          },
          {
            path: 'support',
            name: 'support',
            component: () => import('../views/system/Supporter')
          }
        ]
      },
      {
        path: 'businessSettings',
        name: 'businessSettings',
        component: () => import('../views/businessSettings/index'),
        children: [
          {
            path: 'cluster',
            name: 'cluster',
            component: () => import('../views/businessSettings/Cluster')
          },
          {
            path: 'businessGroup',
            name: 'businessGroup',
            component: () => import('../views/businessSettings/BusinessGroup')
          },
          {
            path: 'dataSource',
            name: 'dataSource',
            component: () => import('../views/businessSettings/DataSource')
          }
        ]
      },
      {
        path: 'searchbykql',
        name: 'SearchByKQL',
        component: () => import('../views/search/index.vue'),
        meta: { title: 'SearchByKQL' }
      },
      {
        path: 'test',
        name: 'Test',
        redirect: '/search/test/unit',
        component: () => import('../views/test/Test'),
        children: [
          {
            path: 'unit',
            name: 'Unit',
            component: () => import('../views/test/Unit')
          },
          {
            path: 'unit/:testName/:testId',
            name: 'Detail',
            component: () => import('../views/test/Detail')
          }
        ]
      },
      {
        path: 'access',
        name: 'access',
        component: () => import('../views/access.vue'),
        meta: { title: 'Access' }
      },
      {
        path: 'monitor',
        name: 'monitor',
        component: () => import('../views/monitor/index'),
        children: [
          {
            path: 'cat',
            name: 'cat',
            component: () => import('../views/monitor/cat')
          },
          {
            path: 'es_task',
            name: 'es_task',
            component: () => import('../views/monitor/EsTask.vue'),
            meta: { title: 'Es Task' }
          }
        ]
      },
      {
        path: 'client',
        name: 'client',
        component: () => import('../views/client/index'),
        children: [
          {
            path: 'user',
            name: 'User',
            component: () => import('../views/client/user')
          },
          // {
          //   path: 'timer',
          //   name: 'Timer',
          //   component: () => import('../views/client/timer')
          // },
          {
            path: 'poolStatus',
            name: 'PoolStatus',
            component: () => import('../views/client/poolStatus')
          },
          {
            path: 'exception',
            name: 'Exception',
            component: () => import('../views/client/exception')
          },
          {
            path: 'endpoint',
            name: 'Endpoint',
            component: () => import('../views/client/endpoint')
          },
          {
            path: 'visualization',
            name: 'Visualization',
            component: () => import('../views/client/visualization')
          }
        ]
      },
      {
        path: 'gateway',
        name: 'gateway',
        component: () => import('../views/gateway/index'),
        children: [
          {
            path: 'gatewayRoute',
            name: 'gatewayRoute',
            component: () => import('../views/gateway/GatewayRoute')
          },
          {
            path: 'clusterRouting',
            name: 'clusterRouting',
            component: () => import('../views/gateway/ClusterRouting')
          },
          {
            path: 'lookupHeader',
            name: 'lookupHeader',
            component: () => import('../views/gateway/LookupHeader')
          },
          {
            path: 'failover',
            name: 'failover',
            component: () => import('../views/gateway/Failover')
          }
        ]
      },
      {
        path: 'agg',
        name: 'agg',
        component: () => import('../views/agg/index'),
        children: [
          {
            path: 'task',
            name: 'Task',
            component: () => import('../views/agg/task')
          },
          {
            path: 'subtask/:id',
            name: 'Subtask',
            component: () => import('../views/agg/subtask')
          },
          {
            path: 'job/:id',
            name: 'Job',
            component: () => import('../views/agg/job')
          }
        ]
      },
      {
        path: 'hbase',
        name: 'HBase',
        component: () => import('../views/search_management/hbase/index'),
        redirect: '/search/hbase/cluster_list',
        children: [
          {
            path: 'cluster',
            name: 'HBaseClusterList',
            component: () =>
              import('../views/search_management/hbase/cluster/list')
          },
          {
            path: 'cluster_detail',
            name: 'HBaseClusterDetail',
            component: () =>
              import('../views/search_management/hbase/cluster/detail')
          },
          {
            path: 'regionserver',
            name: 'HBaseRegionServerList',
            component: () =>
              import('../views/search_management/hbase/regionserver/list')
          },
          {
            path: 'regionserver_detail',
            name: 'HBaseRegionServerDetail',
            component: () =>
              import('../views/search_management/hbase/regionserver/detail')
          },
          {
            path: 'table',
            name: 'HBaseTableList',
            component: () =>
              import('../views/search_management/hbase/table/list')
          },
          {
            path: 'table_detail',
            name: 'HBaseTableDetail',
            component: () =>
              import('../views/search_management/hbase/table/detail')
          }
        ]
      }
    ]
  }
]
